let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8RnnA")).then(() => parcelRequire('5i7M2'));